import React, { useEffect, useState } from "react";
import TextInput from "components/common/InputField/TextInput";
import SelectInput from "components/common/InputField/SelectInput";
import Button from "components/common/Button";
import ModalContainer from "components/common/ModalContainer";
import useGetUserProfile from "hooks/useGetUserProfile";
import { getFromStorage } from "helpers";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import { authActions } from "redux/Ldb/actions";
import { AccountPermissions } from "types/permissions";
import toast from "react-hot-toast";
import CustomToast from "components/common/CustomToast";
import { accessTypes } from "variables";
import useGetTeamRoles from "hooks/teamHooks/useGetTeamRoles";

type AddTeamMemberModalProps = {
    addNewMember: boolean;
    setAddNewMember: (value: boolean) => void;
};

const AddTeamMemberModal = ({ addNewMember, setAddNewMember }: AddTeamMemberModalProps) => {
    const dispatch = useAppDispatch();
    const [profile] = useGetUserProfile();
    const userProfile = getFromStorage("ally-user");
    const [role, setRole] = useState("");
    const [addCustomRole, setAddCustomRole] = useState(false);
    const [selectedPermissions, setSelectedPermissions] = useState<string[]>([]);
    const [teamForm, setTeamForm] = useState({
        email: "",
        role: "",
    });

    const { data: userRoles, isFetching: isFetchingRoles } = useGetTeamRoles(
        profile?.isMultiBrandAccount || profile?.accountType === "brand"
            ? userProfile?.mainToken || userProfile?.token
            : profile?.token
    );
    const {
        fetchingTeamMember,
        fetchedTeamMemberSuccess,
        addingTeamMember,
        addTeamMemberSuccess,
        createRoles,
        createRolesSuccess,
    } = useAppSelector((state) => state.auth);

    const handleTeamFormChange = (name: string, value: any) => {
        setTeamForm((prev) => {
            return {
                ...prev,
                [name]: value,
            };
        });
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const userData = { ...userProfile };
        const body: { [key: string]: any } = {
            // brandIds: [],
            teamMembers: [
                {
                    email: teamForm?.email,
                    role: teamForm?.role,
                },
            ],
        };

        if (profile?.isMultiBrandAccount || profile?.accountType === "brand") {
            body.brandIds = [profile?.parentId || profile?._id];
        }

        dispatch(
            authActions.addTeamMember(
                body,
                profile?.isMultiBrandAccount || profile?.accountType === "brand"
                    ? userData?.mainToken || userData?.token
                    : profile?.token
            )
        );
    };

    const handlePermissionChange = (permission: string) => {
        const isSelected = selectedPermissions.includes(permission);

        if (isSelected) {
            const updatedPermissions = selectedPermissions.filter((item) => item !== permission);
            setSelectedPermissions(updatedPermissions);
        } else {
            setSelectedPermissions([...selectedPermissions, permission]);
        }
    };

    const handleAddRole = () => {
        const userData = { ...userProfile };

        const permission = selectedPermissions;
        if (role === "") {
            toast.custom((t) => (
                <CustomToast t={t} message={"Role name is required"} type="error" />
            ));
        }
        if (role !== "") {
            const teamMember = {
                role,
                ...(permission.length > 0 && { permission }),
            };
            dispatch(
                authActions.createRoles(
                    teamMember,
                    profile?.isMultiBrandAccount || profile?.accountType === "brand"
                        ? userData?.mainToken || userData?.token
                        : profile?.token
                )
            );
        }
    };

    useEffect(() => {
        if (Boolean(createRolesSuccess)) {
            setSelectedPermissions([]);
            setAddCustomRole(false);
            dispatch(authActions.resetCreateRoles());
        }
    }, [createRolesSuccess, dispatch]);

    useEffect(() => {
        if (Boolean(addTeamMemberSuccess)) {
            dispatch(
                authActions.getTeamMembers(
                    40,
                    "",
                    null,
                    profile?.isMultiBrandAccount || profile?.accountType === "brand"
                        ? userProfile?.mainToken || userProfile?.token
                        : profile?.token
                )
            );
            setAddNewMember(false);
        }
    }, [
        dispatch,
        addTeamMemberSuccess,
        profile?.token,
        profile?.isMultiBrandAccount,
        profile?.accountType,
        userProfile?.mainToken,
        userProfile?.token,
    ]);

    console.log(addNewMember, "addNewMember");
    return (
        <>
            <ModalContainer
                open={addNewMember}
                showCloseIcon={false}
                modalClassName={
                    "md:py-10 bg-white !items-start !top-0 !left-0 md:!items-center md:bg-gm-50/20"
                }
                tailwindClassName="w-full md:w-[553px] !overflow-y-visible"
                closeModal={() => {
                    setAddNewMember(false);
                    setTeamForm({
                        // brands: [],
                        email: "",
                        role: "",
                    });
                }}
            >
                <div className="bg-white shadow-cardShadow relative rounded-lg">
                    <div className="w-full md:flex md:justify-center ">
                        <div className="w-full md:w-[553px]">
                            <div className="w-full   md:flex md:text-center items-center md:justify-center">
                                <div className="w-full flex py-4 border-b border-slate-200 text-center items-center justify-center relative">
                                    <span className="text-base font-rocGroteskMedium">
                                        Add a team-mate
                                    </span>
                                    <div className="absolute right-[24px]">
                                        <i
                                            className="ri-close-fill text-2xl cursor-pointer"
                                            onClick={() => {
                                                setAddNewMember(false);
                                                setTeamForm({
                                                    email: "",
                                                    role: "",
                                                });
                                            }}
                                        ></i>
                                    </div>
                                </div>
                            </div>
                            <form
                                onSubmit={(e) => {
                                    handleSubmit(e);
                                }}
                                className="w-full  "
                            >
                                <div className="space-y-6 p-6">
                                    <TextInput
                                        value={teamForm?.email}
                                        name={"email"}
                                        type={"email"}
                                        onChange={(e) => {
                                            handleTeamFormChange(e.target.name, e.target.value);
                                        }}
                                        placeholder={"Email"}
                                        required={true}
                                        containerClassname=""
                                    />

                                    <SelectInput
                                        value={teamForm.role}
                                        name="role"
                                        placeholder="Select role"
                                        handleChange={(name, value) => {
                                            handleTeamFormChange(name, value);
                                        }}
                                        isRequired={true}
                                        searchLoading={isFetchingRoles}
                                        customDropdownContainer={
                                            <div className="w-full py-1.5 flex flex-col gap-3.5">
                                                <div
                                                    onClick={() => setAddCustomRole(true)}
                                                    className="flex items-center gap-1 px-3 font-rocGroteskMedium cursor-pointer w-fit"
                                                >
                                                    <i className="ri-add-fill before:content-['\ea12'] text-p-55 text-xl mt-[-2px]"></i>
                                                    <span className="text-sm text-p-50">
                                                        Add custom role
                                                    </span>
                                                </div>
                                            </div>
                                        }
                                        dropdownOptions={userRoles?.map((role) => {
                                            return {
                                                label: role?.label,
                                                value: role?.role,
                                            };
                                        })}
                                    />
                                </div>

                                <div className="w-full mt-1 py-4 px-6 border-t border-slate-200 flex items-center space-x-2">
                                    <Button
                                        btnText={"Cancel"}
                                        onClick={() => {
                                            setAddNewMember(false);
                                            setTeamForm({
                                                // accessLevel: [],
                                                // brands: [],
                                                email: "",
                                                role: "",
                                            });
                                        }}
                                        disabled={addingTeamMember}
                                        btnClassname={"!bg-tradeally-neutral-20 !text-gm-75 "}
                                    />
                                    <Button
                                        btnText={"Add team-mate"}
                                        isLoading={addingTeamMember}
                                        btnPermission={[
                                            AccountPermissions.all_access,
                                            AccountPermissions.manage_team,
                                        ]}
                                        type={"submit"}
                                        btnClassname=""
                                        btnTextClassName="!text-md"
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </ModalContainer>

            <ModalContainer
                open={addCustomRole}
                showCloseIcon={false}
                modalClassName={"py-10 px-10"}
                tailwindClassName="w-[513px] xl:w-[600px]"
                closeModal={() => {
                    setAddCustomRole(false);
                }}
            >
                <div className="bg-white rounded-lg shadow-modalShadow relative pt-5 pb-10">
                    <div className="flex justify-end px-10">
                        <span
                            onClick={() => setAddCustomRole(false)}
                            className="material-icons text-gm-50 text-xl cursor-pointer"
                        >
                            close
                        </span>
                    </div>
                    <div className="px-10 pt-3">
                        <div className="flex flex-col items-center text-center mb-[45px]">
                            <p className="text-2xl mb-2.5 font-rocGroteskMedium text-g-75">
                                Create a custom role
                            </p>
                            <p className="text-sm font-rocGroteskMedium text-gm-40">
                                Define what the new role’s responsibilities are
                            </p>
                        </div>
                        <form className="w-full">
                            <TextInput
                                name={`role`}
                                type={"text"}
                                placeholder={"Enter role name"}
                                value={role}
                                onChange={(e) => setRole(e.target.value)}
                                required={true}
                                containerClassname={"mb-6"}
                            />
                            <div>
                                <p className="text-base font-rocGroteskMedium mb-6">
                                    Select access levels
                                </p>
                                <div className="flex flex-wrap gap-4 relative max-h-[30vh] overflow-auto">
                                    {accessTypes.map((access, idx) => (
                                        <div
                                            key={idx}
                                            onClick={() => handlePermissionChange(access.value)}
                                            className={`px-2.5 w-fit h-[30px] ${
                                                selectedPermissions.includes(access.value)
                                                    ? "!bg-carribean-green !text-white !border-carribean-green"
                                                    : ""
                                            } border flex items-center gap-2 rounded-[8px] font-rocGroteskMedium bg-white hover:!bg-g-65 hover:text-white hover:!border-g-65 border-slate-300 text-[13px] cursor-pointer`}
                                        >
                                            {selectedPermissions.includes(access.value) ? (
                                                <i className="ri-checkbox-circle-fill text-base"></i>
                                            ) : (
                                                <i className="ri-add-fill text-base"></i>
                                            )}
                                            {access.label}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <Button
                                onClick={handleAddRole}
                                btnText={"Add role"}
                                btnPermission={[
                                    AccountPermissions.all_access,
                                    AccountPermissions.manage_team,
                                ]}
                                isLoading={createRoles}
                                btnClassname={"my-10"}
                            />
                            <p
                                onClick={() => setAddCustomRole(false)}
                                className="text-sm font-rocGroteskMedium text-center cursor-pointer"
                            >
                                Close
                            </p>
                        </form>
                    </div>
                </div>
            </ModalContainer>
        </>
    );
};

export default AddTeamMemberModal;
